module.exports = __webpack_public_path__ + "img/ametist-stone.8bf58f4b.png";